<template>
  <div class="container container-box">
    <div class="list-header">
      <div class="header-line"></div>
      <div class="header-title">{{$t('my.nav.history')}}</div>
    </div>
    <div class="common-list" v-loading.fullscreen="listLoading">
        <NoData v-if="list.length<=0"
                v-bind:title="$t('history.nodata')"></NoData>
        <div v-for="(item,index) in list"
             class="common-item"
             :key="index" >
          <a class="item-a" :href="item.link" target="_blank"></a>
          <div class="li-circle"></div>
          <div class="title-source ellipsis">{{item.title.source}}</div>
          <div class="title-target ellipsis">{{item.title.target}}</div>
          <div class="item-site ellipsis">{{item.site}}</div>
          <div class="item-time">{{item.created_at}}</div>
        </div>
    </div>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>
  </div>
</template>
<style scoped>
  @import "../css/list-item.scss";
</style>
<script>
import { getHistory } from '@/api/user'
import { formatTime } from '@/utils/index'
import jump from 'jump.js'
import NoData from '../components/NoData.vue'

export default {
  components:{NoData},
  data() {
    return {
      list: [],
      listLoading: true,
      page:1,
      page_size: 10,
      busy: true
    }
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(flag) {
      this.listLoading = true
      getHistory({
        page: this.page,
        page_size: this.page_size
      }).then(response => {
        this.listLoading = false
        var list = response.page
        for (var i = 0, l = list.length; i < l; i++) {
          list[i].created_at = formatTime(list[i].read_at)
          list[i].site = new URL(list[i].link).host
        }
        if (flag) {
          // 滚动加载数据
          this.list = this.list.concat(list)
          jump(500, {
            duration: 400
          })
          if (list.length == 0) {
            this.busy = true
           } else{
            this.busy = false
          }
        } else {
          // 首次加载数据
          this.list = list || [];
          this.busy = false
        }

      })
    },
    loadMore: function() {
      this.busy = true
      this.page ++
      this.fetchData(true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/history.vue